export default "__VITE_ASSET__DsNZwawM__"